import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";


interface OcupacionState {
    status: string;
    error: string;
    ocupacionList: any[],
    ocupacionListActive: any[],
    ocupacion: {
        idOcupacion: number | null;
        nombre: string | null;
    }

}

const initialState: OcupacionState = {
    status: 'idle',
    error: '',
    ocupacionList: [],
    ocupacionListActive: [],
    ocupacion: {
        idOcupacion: null,
        nombre: null
    }
}

export const fetchOcupacion = createAsyncThunk('fetchOcupacion', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 35;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchOcupacionActive = createAsyncThunk('fetchOcupacionActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 36;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const ocupacionSlice = createSlice({
    name: 'ocupacion',
    initialState,
    reducers: {
        setOcupacionList: (state, action) => {
            state.ocupacionList = action.payload;
        },
        setOcupacionListActive: (state, action) => {
            state.ocupacionListActive = action.payload;
        },
        setOcupacion: (state, action) => {
            state.ocupacion = !action.payload ? initialState.ocupacion : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchOcupacion.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchOcupacion.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.ocupacionList = data ? data : [];

            })
            .addCase(fetchOcupacion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchOcupacionActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchOcupacionActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.ocupacionListActive = data ? data : [];

            })
            .addCase(fetchOcupacionActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectOcupacionList = (state: RootState) => state.ocupacion.ocupacionList;
export const selectOcupacionListActive = (state: RootState) => state.ocupacion.ocupacionListActive;
export const selectOcupacion = (state: RootState) => state.ocupacion.ocupacion;

export const { setOcupacionList, setOcupacionListActive, setOcupacion } = ocupacionSlice.actions;

export default ocupacionSlice.reducer;